<template>
<div id="SceneComponentList" class="scene-component-list">
  <div class="left-box">
    <div class="scene-component-banner">
      <img class="banner-img" :src="sceneInfo.topPicture" alt="" />
      <div class="banner-text-content">
        <div class="main-content-width">
          <div class="scene-breadcrumb">
            <span class="scene-breadcrumb-title">当前位置：</span>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ name: 'SceneList' }">专题场景库</el-breadcrumb-item>
              <el-breadcrumb-item>{{sceneInfo.name}}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <p class="scene-name">{{sceneInfo.name}}</p>
        </div>
      </div>
    </div>
    <div class="left-content">
      <div class="search-area main-content-width scrollbar-gap">
        <div>
          <el-button v-if="['g', 'r'].includes(platform)" plain :disabled="!selectedCount" @click="loadBatch">批量载入{{ selectedCount? `( ${selectedCount} )`: '' }}</el-button>
        </div>
        <gjw-search placeholder="请输入关键词，以空格隔开" width="240px" @change="keywordChange" />
      </div>
      <div class="operate-area operate-and-layout main-content-width scrollbar-gap">
        <div>
          <el-checkbox v-if="['g', 'r'].includes(platform)" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        </div>
        <div>
          <span class="icon-type" :class="{'active': listType === 'card'}" @click="changeListType('card')">
            <i class="gjw-iconfont gjw-icon-libiao1"/>
          </span>
          <span class="icon-type" :class="{'active': listType === 'row'}" @click="changeListType('row')">
            <i class="gjw-iconfont gjw-icon-libiao2"/>
          </span>
        </div>
      </div>
      <gjw-dimensions @height-changed="getContentHeight">
        <div class="middle-result-box">
          <div class="data-content" :style="{height: `${contentHeight}px`}">
            <div v-if="loading" class="loading-mask" v-loading="loading" element-loading-background="#f5f5fa"></div>
            <ul
              v-if="loading || tableData.length"
              class="list-ul main-content-width"
              :class="{ 'list-ul-card': listType === 'card' }"
            >
              <li
                  class="list-li"
                  :class="listType === 'card' ? 'card-li' : 'row-li'"
                  v-for="(item, index) in tableData"
                  :key="index"
                  @click.stop="openDetail($event, item)"
              >
                <list-item :comp-item="item" :type="listType" @check-change="handleCheckChange" :track-params="trackInfo" />
              </li>
            </ul>
            <div v-else class="empty">
              <empty-content text="未能找到符合条件的构件，可以放宽搜索条件试一试" />
            </div>
          </div>
        </div>
      </gjw-dimensions>
      <div class="middle-pagination-box main-content-width scrollbar-gap">
        <el-pagination
            small
            background
            @current-change="currentChange"
            :current-page="payload.pageNo"
            :page-size="payload.pageSize"
            layout="prev, pager, next"
            :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
  <div v-if="showDetail" class="right-box">
    <detail :detail="detail" @close="closeDetail"/>
  </div>
  <!-- 载入重名弹框 -->
  <check-rename-dialog ref="CheckRenameDialogRef" :dialogVisible="checkRenameDialogVisible" :selectedList="selectedData" @confirm="checkRenameConfirm" @close="checkRenameClose"/>
  <!-- 载入 -->
  <load-progress-bar-dialog ref="LoadProgressBarDialogRef" :selectedList="selectedData" @clearSelection="clearSelection"/>
  <!-- 构件下载 -->
  <web-download-component from="scenes" :track-params="trackInfo" />
</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import GjwDimensions from '@/components/lib/GjwDimensions'
import ListItem from '@/views/components/components/ListItem.vue'
import EmptyContent from '@/components/layout/EmptyContent.vue'
import Detail from '@/views/components/Detail.vue'
import CheckRenameDialog from '@/views/components/components/CheckRenameComponentDialog.vue'
import LoadProgressBarDialog from '@/views/components/components/LoadProgressBarDialog.vue'
import WebDownloadComponent from '@/components/business/WebDownloadComponent.vue'
import { CheckPublicComponentLoaded, GetProjectInfo, LoadPublicComponentInBatch, buildPublicComponentPayload } from '@/core/gcsUtils'
import checkLoginMixin from '@/mixins/checkLoginMixin'
export default {
  name: 'SceneComponentList',
  mixins: [checkLoginMixin],
  components: {
    GjwDimensions,
    ListItem,
    EmptyContent,
    Detail,
    CheckRenameDialog,
    LoadProgressBarDialog,
    WebDownloadComponent,
  },
  data() {
    return {
      sceneId: this.$route.params.id,
      trackInfo: {
        g_c_source: 'scenes',
        g_c_scenes_id: this.$route.params.id
      },
      sceneInfo: {},
      keyword: '',
      tableData: [],
      selectedData: [],
      contentHeight: 0,
      loading: false,
      showDetail: false,
      checkAll: false,
      isIndeterminate: false,
      totalCount: 0,
      payload: { pageNo: 1, pageSize: 49 },
      detail: null,
      checkRenameDialogVisible: false,
    }
  },
  computed: {
    ...mapGetters({
      platform: 'platform',
      softwareCode: 'softwareCode',
      softwareVersion: 'softwareVersion',
      listType: 'scene/componentListType',
    }),
    selectedCount() {
      return this.selectedData.length
    },
    platformCode() {
      const mappingObj = { g: 'NOVA_DESIGN', r: 'REVIT' }
      const key = this.platform
      return mappingObj[key] ? mappingObj[key] : null
    },
  },
  created() {
    this.getSceneInfo()
    this.getSceneComponents()
  },
  methods: {
    ...mapMutations('scene', {
      setComponentListType: 'setComponentListType',
    }),
    // 获取专题信息
    getSceneInfo() {
      this.$api.scene.detail(this.sceneId).then((data) => {
        this.sceneInfo = data || {}
      })
    },
    async getSceneComponents() {
      this.selectedData = []
      this.closeDetail()
      this.loading = true
      const params = {
        pageSize: this.payload.pageSize,
        pageNo: this.payload.pageNo,
        sceneId: this.sceneId,
        keyword: this.keyword,
        platformCode: this.platformCode,
        softwareCode: this.softwareCode || null,
        softwareVersion: this.softwareVersion || null,
      }
      try {
        const res = await this.$api.scene.component(params).catch(() => { this.$message.error('获取数据失败') })
        const list = res.list || []
        if (this.platform === 'web') {
          if (this.user.id) {
            const ids = list.map((item) => { return item.publicComponentId })
            // 获取构件是否已收藏
            const data = await this.$api.components.isFavoriteBatch(ids)
            const isFavoriteObj = data || {}
            list.forEach((item) => {
              item.isFavourite = isFavoriteObj[item.publicComponentId]
            })
          }
        } else {
          const ids = list.map((item) => { return { id: String(item.publicComponentId), name: item.name } })
          // 获取构件是否已添加
          const { data } = await CheckPublicComponentLoaded(ids)
          const componentsLoadedArr = data || []
          list.forEach((item, index) => {
            const loadedObj = componentsLoadedArr.find((it) => String(it.publicComponentId) === String(item.publicComponentId)) || {}
            item.isLoaded = loadedObj.isLoaded
            item.isChecked = false
            item.sortIndex = params.pageSize * (params.pageNo - 1) + index + 1
          })
        }
        this.tableData = list
        this.totalCount = res.totalCount || 0
        this.updateCheckAllStatus()
        // 埋点
        this.$tracks({
          event: 'sceneComponentQuery',
          params: {
            g_c_scene_id: this.sceneInfo.id,
            g_c_scene_name: this.sceneInfo.name,
            g_c_result_count: this.totalCount,
          }
        })
      } finally {
        this.loading = false
      }
    },
    search() {
      this.payload.pageNo = 1
      this.getSceneComponents()
    },
    getContentHeight(obj) {
      console.log(obj.newValue.toFixed(0), 11)
      this.contentHeight = obj.newValue.toFixed(0) - 4
    },
    keywordChange(keyword) {
      this.keyword = keyword
      this.search()
    },
    currentChange(val) {
      this.payload.pageNo = val
      this.getSceneComponents()
    },
    changeListType(type) {
      this.setComponentListType(type)
    },
    handleCheckAllChange(bool) {
      this.tableData = this.tableData.map((item) => {
        item.isChecked = bool
        this.updateSelectedData(item)
        return { ...item, isChecked: bool }
      })
      this.isIndeterminate = false
    },
    handleCheckChange({ item }) {
      this.updateCheckAllStatus()
      this.updateSelectedData(item)
    },
    updateCheckAllStatus() {
      const checkedCount = this.tableData.filter((item) => item.isChecked).length
      const tableLength = this.tableData.length
      this.checkAll = tableLength > 0 && checkedCount === tableLength
      this.isIndeterminate = checkedCount > 0 && checkedCount < tableLength
    },
    updateSelectedData(row) {
      const selectedData = [...this.selectedData]
      const index = selectedData.findIndex((it) => it.id === row.id)
      if (row.isChecked && index === -1) {
        // 添加到selectedData中
        selectedData.push(row)
      } else if (!row.isChecked && index > -1) {
        // 在selectedData中删除
        selectedData.splice(index, 1)
      }
      this.selectedData = selectedData
    },
    // 插件端获取项目信息
    async getProjectInfo() {
      let projectInfo = {}
      if (this.platform === 'g') {
        const { data } = await GetProjectInfo()
        projectInfo = data || {}
      } else if (this.platform === 'r') {
        const { data } = await this.$revitClient.GetProjectInfo()
        projectInfo = data || {}
      }
      return projectInfo
    },
    async openDetail(event, item) {
      if (this.platform === 'web') {
        // 跳转到官网
        const url = `${process.env.VUE_APP_GJW_PORTAL_URL}/detail/${item.publicComponentId}?platformCode=${item.platformCode}&softwareCode=${item.softwareCode}&softwareVersion=${item.softwareVersion}&locationName=Scenes`
        window.open(url, '_blank')
      } else {
        // 点击多选框时，不打开详情页
        if (event.target.className.includes('el-checkbox')) { return }
        this.showDetail = true
        this.detail = item
      }
      const projectInfo = await this.getProjectInfo()
      // 访问详情埋点
      this.$tracks({
        event: 'visitShopComponentDetail',
        params: {
          g_c_component_id: item.publicComponentId,
          g_c_source: 'scenes',
          g_c_scenes_id: this.sceneId,
          g_c_project_id: projectInfo.id,
          g_c_project_file_path: projectInfo.path,
          g_c_project_file_name: projectInfo.name
        }
      })
    },
    closeDetail() {
      this.showDetail = false
      this.detail = {}
    },
    // 批量载入
    async loadBatch() {
      try {
        const login = await this.checkLogin()
        if (login) {
          this.$fullLoading.open('正在载入，请稍候...')
          const params = this.selectedData.map((comp) => buildPublicComponentPayload(comp))
          await LoadPublicComponentInBatch(params)
          // 载入结果提示无需web端进行提示，但需要清空勾选项
          this.selectedData = []
          await this.getSceneComponents()
        }
      } catch (err) {
        this.$message.error('批量载入失败')
      } finally {
        this.$fullLoading.close()
      }
    },
    checkRenameConfirm(data, row, actionType, subdivideType, batchSelectData) {
      switch (actionType) {
        case 'place':
          data.forEach((item) => {
            this.$refs.pluginPlaceTypeDialog?.openDialog(row, true, item.reName === true ? 'FFS_CREATE' : 'FFS_OVERWRITE')
          })
          break
        case 'load':
          if (subdivideType === 'batch') {
            this.$refs.LoadProgressBarDialogRef?.batchOpenDialog(subdivideType, data, batchSelectData)
          }
          break
      }
    },
    checkRenameClose() {
      this.checkRenameDialogVisible = false
    },
    async clearSelection() {
      this.selectedData = []
      await this.getSceneComponents()
    },
  },
}
</script>

<style lang="less" scoped>
.scene-component-list{
  flex: 1;
  display: flex;
  flex-direction: row;
  height: 100%;
  background: #F5F5FA;
  .left-box{
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .right-box{
    flex: 0 0 320px;
    width: 320px;
    background: @white;
    border-left: 1px solid @theme-border-color;
    height: calc(100vh - 40px);
  }
}
.scene-component-banner{
  flex: 0 0 112px;
  position: relative;
  width: 100%;
  height: 112px;
  background: #249FC3;
  text-align: center;
  .banner-img{
    height: 112px;
    max-width: 100%;
  }
  .banner-text-content{
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    text-align: left;
  }
  .scene-breadcrumb{
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 0;
    margin-top: 14px;
    .scene-breadcrumb-title{
      color: rgba(255, 255, 255, 0.65);
    }
  }
  .scene-name{
    font-size: 28px;
    color: #ffffff;
  }
}
.left-content{
  flex: 1;
  display: flex;
  flex-direction: column;
}
// 与列表区 scrollbar-gutter 对齐的固定滚动条宽度
@scrollbar-width: 4px;
.main-content-width{
  width: 100%;
  max-width: 1140px;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
}
// 滚动容器外的区域需额外预留滚动条宽度
.scrollbar-gap{
  padding-right: calc(20px + @scrollbar-width);
}
.search-area{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  &.scrollbar-gap{
    padding-right: calc(20px + @scrollbar-width);
    padding-left: 20px;
  }
}
.operate-area{
  // 与列表区间距放在滚动容器外，滚动时始终保留
  margin-bottom: 10px;
}
.operate-and-layout{
  display: flex;
  justify-content: space-between;
  align-items: center;
  .icon-type{
    display: inline-block;
    cursor: pointer;
    padding: 5px 4px 2px;
    border: 1px solid @theme-border-color;
    border-left: none;
    &:first-child{
      border-left: 1px solid @theme-border-color;
    }
    &.active{
      background: @white;
    }
  }
}
.middle-result-box{
  flex: 1;
}
.middle-pagination-box{
  padding: 6px 0;
  text-align: center;
  border-top: 1px solid @theme-border-color;
}
.data-content{
  position: relative;
  overflow: auto;
  // 始终预留滚动条槽，与上方 scrollbar-gap 对齐
  scrollbar-gutter: stable;
}
.loading-mask {
  position: absolute;
  left:0;
  top:0;
  width: 100%;
  height: 100%;
}
.list-ul{
  overflow: hidden;
  box-sizing: border-box;
}
.list-ul-card{
  display: flex;
  flex-wrap: wrap;
  gap: 16px 20px;
  overflow: visible;
  .card-li{
    flex: 0 0 auto;
    margin: 0;
  }
}
.list-li{
  cursor: pointer;
  border: 1px solid #F5F5FA;
}
.row-li{
  width: 100%;
}
.empty{
  margin-top: 80px;
}
</style>
<!--页面全局样式-->
<style lang="less">
#SceneComponentList{
  .el-breadcrumb__separator{
    color: #ffffff;
  }
  .el-breadcrumb__inner{
    color: #ffffff;
  }
  .el-breadcrumb__inner a:hover, .el-breadcrumb__inner.is-link:hover{
    color: rgba(255, 255, 255, 0.8);
  }

}
</style>
